import {NgModule} from '@angular/core';
import {SideMenuModule} from './side-menu/side-menu.module';

@NgModule({
  declarations: [],
  imports: [SideMenuModule],
  exports: [SideMenuModule],
  providers: []
})
export class CoreMenuModule {

}
